module.exports = __webpack_public_path__ + "static/media/SourceSansPro-BoldIt.bf76fcab.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-BoldIt.woff2
// module id = 352
// module chunks = 3